/**
 * @file Transaction Details Modal Component.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  TRANSACTION_ITEM_TYPE,
  PHOTO_ITEM_TYPE,
  SUBSCRIPTION_ITEM_TYPE,
} from '../../../constants/transactions';
import PhotoTransactionDetails from './components/PhotoTransactionDetails';
import { getProductBasenames } from '../../../util/role-definitions';
import SubscriptionTransactionDetails from './components/SubscriptionTransactionDetails';
import CustomPrintTransactionDetails from './components/CustomPrintTransactionDetails';
import PrintPartnerContactForm from './components/PrintPartnerContactForm';
import DigitalBundleTransactionDetails from './components/DigitalBundleTransactionDetails';
import PrintOrderServiceTransactionDetails from './components/PrintOrderServiceTransactionDetails';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string,
    print_partners: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          print_partner: PropTypes.shape({
            id: PropTypes.string,
          }),
          print_partner_account_id: PropTypes.string,
        }),
      ),
    }),
  }),
  transactionItem: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number,
    }),
    item_type: PropTypes.oneOf(Object.keys(TRANSACTION_ITEM_TYPE)),
    photo_item_type: PropTypes.oneOf(Object.keys(PHOTO_ITEM_TYPE)),
    subscription_item_type: PropTypes.oneOf(
      Object.keys(SUBSCRIPTION_ITEM_TYPE),
    ),
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    photo: PropTypes.shape({
      id: PropTypes.string,
    }),
    transaction: PropTypes.shape({
      id: PropTypes.string,
      uuid: PropTypes.string,
      roes_order_id: PropTypes.string,
    }),
  }),
  basename: PropTypes.oneOf(getProductBasenames()),
};

const TransactionDetails = ({ account, transactionItem, basename }) => {
  console.log(transactionItem);
  switch (transactionItem?.item_type) {
    case TRANSACTION_ITEM_TYPE.PHOTO: {
      return (
        <Fragment>
          <div className="transaction-details-table">
            <PhotoTransactionDetails
              account={account}
              transactionItem={transactionItem}
              basename={basename}
            />
          </div>
          <PrintPartnerContactForm transaction={transactionItem?.transaction} />
        </Fragment>
      );
    }

    case TRANSACTION_ITEM_TYPE.SUBSCRIPTION: {
      return (
        <Fragment>
          <div className="transaction-details-table">
            <SubscriptionTransactionDetails
              transactionItem={transactionItem}
              basename={basename}
            />
          </div>
          <PrintPartnerContactForm transaction={transactionItem?.transaction} />
        </Fragment>
      );
    }

    case TRANSACTION_ITEM_TYPE.CUSTOM_PRINT: {
      return (
        <Fragment>
          <div className="transaction-details-table">
            <CustomPrintTransactionDetails
              account={account}
              transactionItem={transactionItem}
              basename={basename}
            />
          </div>
          <PrintPartnerContactForm transaction={transactionItem?.transaction} />
        </Fragment>
      );
    }

    case TRANSACTION_ITEM_TYPE.DIGITAL_BUNDLE: {
      return (
        <Fragment>
          <div className="transaction-details-table">
            <DigitalBundleTransactionDetails
              transactionItem={transactionItem}
              basename={basename}
            />
          </div>
          <PrintPartnerContactForm transaction={transactionItem?.transaction} />
        </Fragment>
      );
    }

    case TRANSACTION_ITEM_TYPE.PRINT_ORDER_SERVICE: {
      return (
        <Fragment>
          <div className="transaction-details-table">
            <PrintOrderServiceTransactionDetails
              transactionItem={transactionItem}
              basename={basename}
            />
          </div>
          <PrintPartnerContactForm transaction={transactionItem?.transaction} />
        </Fragment>
      );
    }

    default: {
      return null;
    }
  }
};

TransactionDetails.propTypes = propTypes;

export default TransactionDetails;
